import Vue from "vue";

const config = {
  title: "Reci BASE"
};

Vue.prototype.$config = config;
